import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { Loading } from '@e3dc-react/shell/Elements/Loading'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { SettingsFormValues } from 'src/Elements/SystemSettings/Battery/types'
import { FarmBatteryModel } from 'src/Libs/batteries'
import { makeStyles } from 'tss-react/mui'
import StorageBatterySettingsData from './StorageBatterySettingsData'

interface Props {
  model: FarmBatteryModel
  batteryId: string
  onUpdate: (storageSerialNo: string, values: SettingsFormValues, batteryId: string) => Promise<boolean | null>
  isReadOnlyAccess?: boolean
  isLoading: boolean
}

const useStyles = makeStyles()(theme => ({
  contentAccordion: {
    padding: theme.spacing(0),
  },
  headerContent: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(4),
    },
  },
}))

const WHITE_SPACE = '\u2003' /* Unicode character for a space that is wider than a regular space, used for better visual separation in the title. */

const StorageBatterySettingItem: React.FC<Props> = ({ model, batteryId, onUpdate, isReadOnlyAccess = true, isLoading }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  const batteryIdHumanReadable = Number(batteryId) + 1
  const batteryName = `${t('framework.battery')} ${batteryIdHumanReadable}`
  const title = model
    ? `${model.storageName ?? model.storageSerialNo}${WHITE_SPACE}${batteryName}`
    : t('systemSettings.battery.settings.sectionTitle')

  return (
    <AccordionItem expanded title={title} contentClassName={classes.contentAccordion} headerContentClassName={classes.headerContent}>
      <StorageBatterySettingsData model={model} onUpdate={onUpdate} batteryId={batteryId} isReadOnlyAccess={isReadOnlyAccess} />
      {isLoading && <Loading />}
    </AccordionItem>
  )
}

export default StorageBatterySettingItem
